
import { wfVueExtensionsVars } from "../extensions";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			showSlot: false,
			parentShow: false,
			modalDepthAdded: false
		};
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		transition: {
			type: String,
			default: "fade-enter"
		},
		escapeClose: {
			type: Boolean
		},
		clickClose: {
			type: Boolean
		},
		fullHeight: {
			type: Boolean
		}
	},
	watch: {
		value: {
			immediate: true,
			async handler(val:boolean) {
				if (val){
					this.addModalDepth();
				}else{
					this.removeModalDepth();
				}
				await this.$nextTick();
				if (val) {
					if(document.activeElement && (document.activeElement as HTMLElement).blur){
						(document.activeElement as HTMLElement).blur();
					}
					this.parentShow = true;
					await this.$nextTick();
					let innerModal = (this.$refs.innerModal as HTMLDivElement);
					if (!innerModal){
						this.$once("mounted", ()=>{
							innerModal.focus();
						});
					}else{
						innerModal.focus();
					}
				} else {
					this.showSlot = false;
				}
			}
		},
	},
	methods: {
		onEscapeKey(event:KeyboardEvent) {
			if (event.code == "Escape") {
				if (this.escapeClose) {
					this.$emit("input", false);
				}
			}
		},
		onClickClose() {
			if(this.clickClose){
				this.$emit("input", false);
			}
		},
		addModalDepth(){
			if (this.modalDepthAdded) return;
			wfVueExtensionsVars.modalDepth++;
			this.modalDepthAdded = true;
		},
		removeModalDepth(){
			if (!this.modalDepthAdded) return;
			wfVueExtensionsVars.modalDepth--;
			this.modalDepthAdded = false;
		}
	},
	updated() {
		if (this.value) {
			this.showSlot = true;
		} else {
			this.parentShow = false;
		}
	},
	mounted() {
		window.addEventListener("keydown", this.onEscapeKey, true);
		this.$emit("mounted");
	},
	destroyed() {
		window.removeEventListener("keydown", this.onEscapeKey, true);
		this.removeModalDepth();
	}
});
